// extracted by mini-css-extract-plugin
export default {"search-feed-admin-right-side":"SearchFeedAdminRightSide_search-feed-admin-right-side__cJ1jU"};